import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Check your .env.local file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// Database types for TypeScript
export type Database = {
  public: {
    Tables: {
      organisations: {
        Row: {
          id: string;
          name: string;
          industry: string | null;
          size: string | null;
          owner_id: string;
          admin_email: string;
          admin_name: string;
          gdpr_consent: boolean;
          gdpr_consent_date: string | null;
          data_processing_agreement: boolean;
          is_active: boolean;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          name: string;
          industry?: string | null;
          size?: string | null;
          owner_id: string;
          admin_email: string;
          admin_name: string;
          gdpr_consent?: boolean;
          gdpr_consent_date?: string | null;
          data_processing_agreement?: boolean;
          is_active?: boolean;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          name?: string;
          industry?: string | null;
          size?: string | null;
          owner_id?: string;
          admin_email?: string;
          admin_name?: string;
          gdpr_consent?: boolean;
          gdpr_consent_date?: string | null;
          data_processing_agreement?: boolean;
          is_active?: boolean;
          created_at?: string;
          updated_at?: string;
        };
      };
      employees: {
        Row: {
          id: string;
          org_id: string;
          email: string;
          name: string;
          phone: string | null;
          password_hash: string;
          temporary_password: string | null;
          awareness_score: number;
          risk_level: string;
          streak: number;
          joined_at: string;
          last_active: string | null;
          last_password_change: string | null;
          invitation_status: string;
          is_active: boolean;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          org_id: string;
          email: string;
          name: string;
          phone?: string | null;
          password_hash: string;
          temporary_password?: string | null;
          awareness_score?: number;
          risk_level?: string;
          streak?: number;
          joined_at?: string;
          last_active?: string | null;
          last_password_change?: string | null;
          invitation_status?: string;
          is_active?: boolean;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          org_id?: string;
          email?: string;
          name?: string;
          phone?: string | null;
          password_hash?: string;
          temporary_password?: string | null;
          awareness_score?: number;
          risk_level?: string;
          streak?: number;
          joined_at?: string;
          last_active?: string | null;
          last_password_change?: string | null;
          invitation_status?: string;
          is_active?: boolean;
          created_at?: string;
          updated_at?: string;
        };
      };
    };
    Views: {
      organisation_analytics: {
        Row: {
          org_id: string;
          org_name: string;
          total_employees: number;
          active_employees: number;
          avg_awareness_score: number;
          total_simulations: number;
          correct_responses: number;
          success_rate: number;
        };
      };
    };
    Functions: {};
  };
};
